
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { uiStore, documentStore, configStore } from "@/store/store";
import IconButton from "@/components/UI/IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import ElementBadge from "./ElementBadge.vue";
import { getProBadge } from "@/lib/subscriptions/free-mode";
import OxygenTagChooser from "@/oxygen/properties-panel/OxygenTagChooser.vue";
import { COMPONENT_SLUG } from "@/lib/elements/constants";

@Component({
  components: {
    Dropdown,
    IconButton,
    ElementBadge,
    OxygenTagChooser
  }
})
export default class Titlebar extends Vue {
  @Prop()
  size!: string;

  get element() {
    return uiStore.activeElement;
  }

  get elementId() {
    return uiStore.activeElementId;
  }

  get elementTitle() {
    return this.element
      ? configStore.element(this.element.data.type).name
      : "No Active Element"; /* should never happen */
  }

  get elementBadges() {
    if (!this.element) return [];

    const element = configStore.element(this.element.data.type);

    const badges = element.badge ? [element.badge] : [];

    if (
      element.settings &&
      element.settings.proOnly &&
      configStore.subscriptionMode === "free"
    ) {
      badges.push(getProBadge());
    }

    return badges;
  }

  get isComponent() {
    if (!this.element) return false;
    return this.element?.data?.type === COMPONENT_SLUG;
  }

  get builderMode() {
    return configStore.builderMode;
  }

  duplicateElement() {
    if (this.elementId) {
      documentStore.duplicateElementAndActivateIt(this.elementId);
    }
  }

  remove() {
    if (this.elementId !== null) {
      documentStore.deleteElement({
        nodeId: this.elementId
      });
    }
  }
}
